import { slsClient } from '../../clients/slsClient'
import { medicareApiClient } from '../../clients/medicareApiClient'
import {
  clearUser,
  setUser
} from '../reducers/users'

export const fetchUserCode = async (dispatch: any) => {
  try {
    const { req_token: slsRequestToken } = await slsClient.getReqToken()

    if (slsRequestToken) {
      // This call gets us our MAX token
      const publicBeneficiary = await medicareApiClient.asyncGetBeneficiaryByReqToken(slsRequestToken)
      dispatch(setUser(publicBeneficiary))
      return Boolean(publicBeneficiary)
    } else {
      throw Error('no slsRequestToken, see fetchUser thunk')
    }
  } catch (error) {
    console.error(error)
    // If a sls request token was retrieved and medicare api did not return a user, unset the temp user
    dispatch(clearUser())
    // alert('There was an error fetching the beneficiary')
  }
}
